export class BrowserService {
    setTitle(title) {
        document.title = title;
    }
    openLink(url) {
        setTimeout(() => {
            window.open(url);
        }, 0);
    }
    close() {
        window.close();
    }
    setLeft(params) {
    }
    getLocation(params) {
        return Promise.reject();
    }
    mapSearch(params) {
        return Promise.reject();
    }
    mapView(params) {
    }
    scan(params) {
    }
    uploadImageFromCamera(params) {
    }
}
